import { render, staticRenderFns } from "./logwood-package-id.vue?vue&type=template&id=733e69cc&scoped=true&"
import script from "./logwood-package-id.vue?vue&type=script&lang=ts&"
export * from "./logwood-package-id.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733e69cc",
  null
  
)

export default component.exports